module.exports = __webpack_public_path__ + "static/media/users-cog.f896a5da.svg";